// ============================================================
// THE BAND A PLATE'S LINES WEAR (plan plate-unboxed): the health ramp's
// five bands, read exactly as the wounds readout reads them (`vitalsOf`,
// so a horde by its magnitude), with Dead over all of them.
//
// The readout shows the band to every viewer - its colour even when the
// table hides the numbers - so a plate in the band's colour tells no one
// anything the readout below it does not.
//
// Pure. Zero React dependency.
// ============================================================

import { healthBand, vitalsOf, type HealthBand } from '../healthRamp';
import type { Target } from '../../types';

/** A health band, `dead` once the body is dead, or `unknown` with no maximum (the plate keeps its side's colour). */
export type PlateBand = HealthBand | 'dead';

/** The band for a body's lines: `dead` when it is dead, else the readout's band for its wounds or magnitude. */
export function plateBand(target: Target, dead: boolean): PlateBand {
  if (dead) return 'dead';
  const { shown, total } = vitalsOf(target);
  return healthBand(shown, total);
}
